import { render, staticRenderFns } from "./MyPrescriptions.vue?vue&type=template&id=39f02881&scoped=true&"
import script from "./MyPrescriptions.vue?vue&type=script&lang=js&"
export * from "./MyPrescriptions.vue?vue&type=script&lang=js&"
import style0 from "./MyPrescriptions.vue?vue&type=style&index=0&id=39f02881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f02881",
  null
  
)

export default component.exports